import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { userManager } from '~/services/oidc';

export const PopupCallback = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // This resolves the popup promise in the opener and closes the popup.
    userManager.signinPopupCallback().catch((err) => {
      console.error('signinPopupCallback error:', err);
      // In case closing doesn't happen automatically:
      window.close();
    });
  }, []);

  return <div>{t('Login.popupCallbackMessage')}</div>;
};
